'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VisibilitySelector = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseRadioButton = require('@bibliocommons/base-radio-button');

var _baseRadioButton2 = _interopRequireDefault(_baseRadioButton);

var _constantsList = require('@bibliocommons/constants-list');

var _visibilityLocationSelector = require('../../visibility-location-selector');

var _visibilityLocationSelector2 = _interopRequireDefault(_visibilityLocationSelector);

require('../styles/VisibilitySelector.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisibilitySelector = exports.VisibilitySelector = function (_BcReactComponent) {
  _inherits(VisibilitySelector, _BcReactComponent);

  function VisibilitySelector(props) {
    _classCallCheck(this, VisibilitySelector);

    var _this = _possibleConstructorReturn(this, (VisibilitySelector.__proto__ || Object.getPrototypeOf(VisibilitySelector)).call(this, props));

    _this.bindAll('renderVisibilityOption');
    return _this;
  }

  _createClass(VisibilitySelector, [{
    key: 'renderVisibilityOption',
    value: function renderVisibilityOption(value) {
      var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      return _react2.default.createElement(
        'div',
        { className: 'list-visibility-option ' + className },
        _react2.default.createElement(_baseRadioButton2.default, {
          id: 'list-visibility-' + value,
          name: 'list-visibility',
          value: value,
          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_visibility_' + value }),
          'data-test-id': 'list-visibility-radio-button-' + value,
          checked: this.props.visibility === value,
          handleChange: this.props.handleVisibilityChange })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-visibility-selector' },
        _react2.default.createElement(
          'fieldset',
          { className: 'list-visibility' },
          _react2.default.createElement(
            'legend',
            { className: 'list-visibility-label' },
            _react2.default.createElement(
              'h2',
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_who_can_see' })
            )
          ),
          this.renderVisibilityOption(_constantsList.VISIBILITY.EVERYWHERE),
          this.renderVisibilityOption(_constantsList.VISIBILITY.GEOFENCED, 'geofenced-visbility'),
          this.props.visibility === _constantsList.VISIBILITY.GEOFENCED ? _react2.default.createElement(_visibilityLocationSelector2.default, {
            listLocales: this.props.listLocales,
            location: this.props.location,
            handleChange: this.props.handleVisibilityLocationChange }) : null,
          this.renderVisibilityOption(_constantsList.VISIBILITY.LINK),
          this.renderVisibilityOption(_constantsList.VISIBILITY.NOT_VISIBLE)
        )
      );
    }
  }]);

  return VisibilitySelector;
}(_baseBcReactComponent2.default);

VisibilitySelector.propTypes = {
  listLocales: _reactImmutableProptypes2.default.map.isRequired,
  visibility: _react.PropTypes.string,
  location: _react.PropTypes.string,
  handleVisibilityChange: _react.PropTypes.func.isRequired,
  handleVisibilityLocationChange: _react.PropTypes.func.isRequired
};

exports.default = VisibilitySelector;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/visibility-selector/components/VisibilitySelector.component.js
// module id = 1354
// module chunks = 0